import classNames from 'classnames';
import debounce from 'lodash/debounce';
import { Component } from 'react';
import { connect } from 'react-redux';
import { ReactOnRailsRootComponent } from '@common/ReactOnRails';
import { storeGenderFilter, toggleFilter } from '../actions/filtersActions';
import { GenderFilterItem } from './GenderFilterItem';
import '../styles/GenderFilter.scss';

class GenderFilter extends Component {
    constructor(props) {
        super(props);
        this.props.saveGenderFilterInStore();
    }

    render() {
        const {
            customClass,
            genderFilter,
            filterClick,
            activeFilters,
            theme
        } = this.props;

        const renderedContent = typeof genderFilter !== 'undefined'
            && genderFilter.map((gender) => {
                const isActive = element => (element.filterType === 'gender' && element.value === gender.value);
                const isSelected = activeFilters ? activeFilters.some(isActive) : false;

                return (
                    <GenderFilterItem
                        key={gender.value}
                        filter={gender}
                        isActive={isSelected}
                        onClick={filterClick}
                    />
                );
            });

        return (
            <div className={classNames('gender-filter', customClass, { [`gender-filter--${theme}`]: theme })}>
                {renderedContent}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    activeFilters: state.filters.activeFilters,
    genderFilter: state.filters.genderFilter
});

const mapDispatchToProps = dispatch => ({
    saveGenderFilterInStore: () => {
        if (typeof App !== 'undefined') {
            // parse gender filter
            const genderFilter = App.Config.Listing.filters?.gender?.map(filterItem => ({
                value: String(filterItem.id),
                name: filterItem.name,
                filterType: 'gender'
            })) ?? [];
            // save genderFilter in store
            dispatch(storeGenderFilter(genderFilter));
        }
    },
    filterClick: debounce((filter) => {
        dispatch(toggleFilter(filter));
    }, 250, {
        leading: true,
        trailing: false
    })
});

const GenderFilterWrapped = connect(mapStateToProps, mapDispatchToProps)(GenderFilter);

export const GenderFilterStandalone = ReactOnRailsRootComponent(GenderFilterWrapped, { withReduxStore: true });
export default GenderFilterWrapped;
